export const actionTypes = {
    FETCH_BOOKMARKED_MAPS_SUCCESS: 'SOCIAL/FETCH_BOOKMARKED_MAPS_SUCCESS',
    FETCH_BOOKMARKED_MAPS_ISLOADING: 'SOCIAL/FETCH_BOOKMARKED_MAPS_ISLOADING',
};
